import React from 'react'

import { TabHeader } from '@containers/Headers/TabHeader'
import { ScreenContainer } from '@containers/ScreenContainer'
import { MidstreamTaskList } from '@containers/Task/Lists/MidstreamList'

export function Todo() {
  return (
    <ScreenContainer header={<TabHeader />}>
      <MidstreamTaskList />
    </ScreenContainer>
  )
}
